<script>
export default {
  name: 'CpLawmakerPage',
  directives: {
    marginTop: require('../directives/margins').marginTop,
    marginBottom: require('../directives/margins').marginBottom,
    marginRight: require('../directives/margins').marginRight,
    marginLeft: require('../directives/margins').marginLeft,
  },
  components: {
    CpBox: require('../box').default,
    CpBoxContent: require('../box-content').default,
    CpPageContent: require('../page-content').default,
    CpGrid: require('../grid').default,
    CpGridItem: require('../grid-item').default,
    CpImage: require('../image').default,
    CpButtonLink: require('../button-link').default,
    CpButton: require('../button').default,
    CpSocialShareDialog: require('../dialogs/social-share').default,
    CpBaseSvgIcon: require('../base-svg-icon').default,
    EndorseIcon: require('../social-feed/icons/endorse').default,
    CpStateIcon: require('../social-feed/icons/state-icon').default,
    CpCampaignTool: require('./components/CampaignTool').default,
    CpSocialMedia: require('./components/SocialMedia').default,
    CpLawmakerActivity: require('./components/LawmakerActivity').default,
    CpLobbyAction: require('./components/LobbyAction').default,
    DemocratIcon: require('../user-profile/icons/political-party/democrat').default,
    RepublicanIcon: require('../user-profile/icons/political-party/republican').default,
    LibertarianIcon: require('../user-profile/icons/political-party/libertarian').default,
    GreenIcon: require('../user-profile/icons/political-party/green').default,
    ConstitutionIcon: require('../user-profile/icons/political-party/constitution').default,
    OtherPartyIcon: require('../user-profile/icons/political-party/other').default,
    CpTruncateText: require('../components/TruncateText').default,
    CpShowInteractionsCount: require('../components/ShowInteractionsCount').default,
    LikeActionButton: require('../social-feed/actions/like-action-button').default,
    CommentActionButton: require('../social-feed/actions/comment-action-button').default,
    CpCommentsPost: require('../comments/box-comments').default,
    CpLikesProfiles: require('../likes/likes-profiles').default,
    CpDialog: require('../dialog').default,
    handleImageError: require('../mixins/utils').default,
    formatOfficeName: require('../mixins/utils').default,
  },
  props: {
    official: {
      type: Object,
      required: true,
    },
    forShare: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      type: 'officials',
      showLikesModal: false,
      officialToLobby: {
        ...this.official,
        full_name: this.official.full_name,
        email: this.official.officeholder_email,
        email_valid: this.official.email_valid,
        phone: this.official.officeholder_phone,
        full_office_address: this.official.officeholder_mailing_address,
        type_charge: 'official',
      },
      currentTab: 'constituent-activity',
    };
  },
  mounted() {
    const currentUrl = window.location.search;
    const urlParams = new URLSearchParams(currentUrl);
    const lobbyType = urlParams.get('type_action');

    if (lobbyType && this.$refs.lobbyActionComponent) {
      this.$nextTick(() => {
        this.$refs.lobbyActionComponent.handleTypeLobby?.(lobbyType);
      });
    }
  },
  computed: {
    isCustomParty() {
      return (
        this.official.party_affiliation !== 'Democrat' &&
        this.official.party_affiliation !== 'Republican' &&
        this.official.party_affiliation !== 'Libertarian' &&
        this.official.party_affiliation !== 'Green' &&
        this.official.party_affiliation !== 'Constitution' &&
        this.official.party_affiliation !== null
      );
    },
    stateIcon() {
      return () => import(`../social-feed/icons/states/${this.official.state}`);
    },
  },
  methods: {
    handleCountLikes(value) {
      value ? (this.official.likes_count = this.official.likes_count + 1) : (this.official.likes_count = this.official.likes_count - 1);
    },
    handleLikesModal() {
      this.showLikesModal = !this.showLikesModal;
    },
    setTab(tab) {
      this.currentTab = tab;
      window.location.hash = '#' + tab;
      this.$refs.activityComponent.setDefaultLobbiesValues();
    },
  },
};
</script>
<template>
  <div>
    <CpBox>
      <CpPageContent v-margin-top="$root.isMobile ? 1 : 3" v-margin-bottom="$root.isMobile ? 1 : 2">
        <CpGrid :column="$root.isMobile" :class="$root.isMobile ? 'text-center' : ''">
          <CpGridItem span="content">
            <div class="circle-image-container">
              <div class="circle-container">
                <img :src="`${official.large_img}`" alt="Official's image" @error="handleImageError" />
              </div>
              <span class="stateIcon">
                <component v-bind:is="stateIcon" class="primary-color" />
              </span>
            </div>
          </CpGridItem>
          <CpGridItem span="auto">
            <CpGrid>
              <CpGridItem :span="$root.isMobile ? 12 : 10">
                <h1 class="H2 black-color" v-margin-bottom="0" v-margin-top="0">{{ official.full_name }}</h1>
                <p class="body black-color" v-margin-top="0" v-html="formatOfficeName(official.office_name)"></p>
              </CpGridItem>
              <CpGridItem :span="$root.isMobile ? 12 : 2">
                <OtherPartyIcon v-if="isCustomParty" />
                <DemocratIcon v-else-if="official.party_affiliation === 'Democrat' && !official.hide_party_affiliation" />
                <RepublicanIcon v-else-if="official.party_affiliation === 'Republican' && !official.hide_party_affiliation" />
                <LibertarianIcon v-else-if="official.party_affiliation === 'Liberterian' && !official.hide_party_affiliation" />
                <GreenIcon v-else-if="official.party_affiliation === 'Green' && !official.hide_party_affiliation" />
                <ConstitutionIcon v-else-if="official.party_affiliation === 'Constitution' && !official.hide_party_affiliation" />
              </CpGridItem>
            </CpGrid>
            <div v-if="official.bio" class="bio-container">
              <h3 class="body neutral5-color" v-margin-top="0">About me</h3>
              <CpTruncateText :lineClamp="1" moreButtonInSameLine :content="official.bio" />
            </div>

            <CpSocialMedia :official="official" v-margin-top="1" />

            <div v-if="!forShare" class="profile-btns" v-margin-top="1">
              <CpLobbyAction
                v-margin-right="1"
                ref="lobbyActionComponent"
                :politician="officialToLobby"
                :refProp="$refs.activityComponent"
                :showTitleButton="false"
              />
              <div class="interactionButtons">
                <div class="post-action-button like">
                  <LikeActionButton :type="type" :id="official.id" :liked="official.liked" :onSuccess="handleCountLikes" />
                </div>
                <div class="post-action-button comment" @click="setTab('comments')">
                  <CommentActionButton :type="type" :id="official.id" />
                </div>
                <div class="post-action-button share">
                  <CpSocialShareDialog
                    class="feed"
                    :allow-share-feed="true"
                    :type="type"
                    :post="official"
                    share-category="Official"
                    share-button-class="button--noborder"
                    :url="official.permalink"
                    :explore="true"
                    :title="`Official information for ${official.full_name}`"
                    :description="official.bio"
                    :quote="official.full_name"
                    hashtags="crowdpac,politics,political crowdfunding"
                    twitter-user="crowdpac"
                  />
                </div>
              </div>
            </div>
            <div v-if="!forShare" v-margin-top="1" class="interactionsCountContainer">
              <CpShowInteractionsCount
                :type="type"
                :id="official.id"
                :likesCount="official.likes_count"
                :commentsCount="0"
                :handleLikesModal="handleLikesModal"
              />
            </div>
          </CpGridItem>
        </CpGrid>
        <CpCampaignTool v-if="official.crowdblue_campaign_page || official.official_campaign_page" :official="official" v-margin-top="1" />
      </CpPageContent>
    </CpBox>

    <CpLawmakerActivity ref="activityComponent" :user="official" :tab="currentTab" />

    <CpDialog v-if="showLikesModal && !forShare">
      <CpLikesProfiles :count-likes="official.likes_count" :id="parseInt(official.id)" :type="type" @close="handleLikesModal" />
    </CpDialog>
  </div>
</template>
<style scoped>
.bio-container {
  border-radius: 6px;
  background-color: var(--neutral1);
  padding: 12px;
}

.profile-btns {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.interactionsCountContainer {
  min-height: 1px;
}

.interactionButtons {
  display: flex;
  justify-content: center;
  align-items: center;
}

.iconContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.stateIcon {
  position: absolute;
  right: 0;
  bottom: -20px;
  height: 60px;
}

.circle-image-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle-container {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width: 768px) {
  .profile-btns {
    flex-direction: column;
  }
  .stateIcon {
    left: 50%;
    right: 50%;
  }
}
</style>
